import z from "zod";

const groupTagSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  groups: z.number().optional(),
  url: z.string().optional(),
  uses: z.number().optional(),
  pinned: z.boolean().optional().catch(false),
  visible: z.boolean().optional().default(true),
}).transform((tag) => ({
  ...tag,
  id: tag.id || tag.name,
}));

type GroupTag = z.infer<typeof groupTagSchema>;

export { groupTagSchema, type GroupTag };
